import {ThemeDefinition} from '@volkswagen-onehub/components-core';
import {EMobilityToolsFeatureAppTheme} from '@volkswagen-onehub/whitelabel-e-mobility-commons';

export function createEMobilityToolsFeatureAppThemeV26(
  theme: ThemeDefinition
): EMobilityToolsFeatureAppTheme {
  return {
    colors: {
      app: {
        background: theme.colors.background.primary,
      },
      inputArea: {
        background:
          'linear-gradient(167deg, rgba(255, 255, 255, 0.80) 0%, rgba(255, 255, 255, 0.20) 60%, rgba(255, 255, 255, 0.00) 100%)', //TODO: backgrounds-cardEmphasis ?
        shadow: theme.colors.shadow.default,
        drivingProfileSlider: {
          evenBackground: 'transparent',
          oddBackground: 'transparent',
          separator: theme.colors.border.default,
          text: theme.colors.content.active,
          thumb: {
            background: {
              default: theme.colors.controllers.on.default,
              hover: theme.colors.controllers.on.hover,
              focus: theme.colors.controllers.on.default,
            },
            border: {
              default: theme.colors.controllers.on.default,
              hover: theme.colors.controllers.on.hover,
              focus: theme.colors.focus.main,
            },
            text: {
              default: theme.colors.content.inverted,
              focus: theme.colors.content.inverted,
            },
          },
        },
        genericChoiceButton: {
          background: {
            default: 'transparent',
            selected: 'transparent',
          },
          border: {
            default: theme.colors.border.default,
            selected: theme.colors.filter.on.default,
            hover: theme.colors.filter.off.hover,
            focus: theme.colors.focus.main,
            disabled: theme.colors.border.disabled,
          },
          content: {
            default: theme.colors.content.primary,
            selected: theme.colors.content.primary,
            hover: theme.colors.content.primary,
            focus: theme.colors.content.primary,
            disabled: theme.colors.content.disabled,
          },
        },
      },
      resultArea: {
        background: theme.colors.content.primary,
        borderColor: theme.colors.border.default,
      },
    },
    elements: {
      modelSelectionArea: {
        header: {
          marginTop: '35px', // this is because the corresponding headline's wrapper in the input section is higher due to the information button's height
        },
        gap: theme.size.static200,
      },
      inputArea: {
        combustionPriceLayout: {
          gap: theme.size.static250,
        },
        genericChoiceButton: {
          border: {
            radius: {
              default: theme.size.borderRadius.small,
              focus: theme.size.borderRadius.small,
            },
            width: {
              default: '1px',
              selected: '2px',
            },
          },
          padding: {
            mobile: {
              withIcon: `7px ${theme.size.static200}`,
              withoutIcon: `${theme.size.static150} ${theme.size.static250}`,
            },
            desktop: {
              withIcon: theme.size.static250,
              withoutIcon: `${theme.size.static150} ${theme.size.static200}`,
            },
          },
          gap: theme.size.static200,
        },
        drivingProfileSlider: {
          borderRadius: theme.size.borderRadius.small,
        },
        borderRadius: {
          default: theme.size.borderRadius.cardL,
          secondary: theme.size.borderRadius.cardL,
        },
      },
      disclaimersArea: {
        marginTop: theme.size.dynamic0150,
      },
      efficiencyDataSeparator: '\u00a0• ',
      resultArea: {
        borderRadius: theme.size.borderRadius.cardS,
      },
    },
    spacing: {
      appLayout: {
        blockGap: theme.size.grid001,
      },
      simulatorHeaderLayout: {
        inlineStart: theme.size.grid002,
        inlineEnd: theme.size.grid002,
      },
      oneColumnSimulatorContentLayout: {
        inlineStart: theme.size.grid002,
        inlineEnd: theme.size.grid002,
        blockGap: theme.size.static350,
      },
      simulatorLayout: {
        blockGap: theme.size.dynamic0130,
      },
      twoColumnSimulatorContentLayout: {
        inlineStart: theme.size.grid002,
        inlineEnd: theme.size.grid002,
        inlineGap: theme.size.grid001,
        blockGap: theme.size.static350,
        sectionColumnWidth: {
          carSelection: '2.45fr',
          inputs: '4.2fr',
        },
      },
      inputSectionLayout: {
        inlineStart: 'var(--input-section-layout-inline-start)',
        inlineEnd: 'var(--input-section-layout-inline-end)',
        blockStart: theme.size.dynamic0130,
        blockEnd: theme.size.dynamic0130,
      },
      faqLayout: {
        inlineStart: theme.size.grid002,
        inlineEnd: theme.size.grid002,
      },
      infoIconOffset: '-4px',
      inputSectionVerticalGap: 'var(--input-simulator-vertical-gap)',
      resultSectionLayout: {
        inlineStart: 'var(--result-section-layout-inline-start)',
        blockStart: 'var(--result-section-layout-block-start)',
      },
      questionsMarginBottom: theme.size.static200,
    },
  };
}
